import {apiQueryV2} from "../utils/Extensions";
import {AssignOrderDTO, SendOnWayDTO} from "../../types/order/OrderDTO";
import {createApi} from "@reduxjs/toolkit/query/react";


export const assignApi = createApi({
    reducerPath: "assignOrder",
    baseQuery: apiQueryV2,
    endpoints: builder => ({
        assign: builder.mutation<void, Partial<AssignOrderDTO>>({
            query: data => ({
                url: "/deliveries/assign",
                method: "POST",
                body: data
            })
        }),
        sendOnWay: builder.mutation<void, Partial<SendOnWayDTO>>({
            query: data => ({
                url: "/deliveries/on-way",
                method: "POST",
                body: data
            })
        }),
        cancelAssign: builder.mutation<void, Partial<string>>({
            query: courierId => ({
                url: "/deliveries/cancel-assign",
                method: "PATCH",
                body: {courierId: courierId}
            })
        })
    })
})

export const {
    useAssignMutation,
    useSendOnWayMutation,
    useCancelAssignMutation
} = assignApi